import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MARKETING: AppRouteRecordRaw = {
  path: '/marketing',
  name: 'marketing',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '营销活动管理',
    icon: 'icon-apps',
    requiresAuth: true,
    order: 7,
  },
  children: [
    {
      path: 'recharge-activity',
      name: 'RechargeActivityManage',
      component: () => import('@/views/partner/recharge-activity/index.vue'),
      meta: {
        locale: '充值活动管理',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default MARKETING;
